import { render, staticRenderFns } from "./add-section-item-button.vue?vue&type=template&id=b726eb52&"
import script from "./add-section-item-button.vue?vue&type=script&lang=ts&"
export * from "./add-section-item-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports